import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import {
  Row,
  Col,
  Card,
  Tooltip,
  Input,
  Checkbox,
  message,
  Spin,
  Collapse,
  Modal,
  Switch,
  Tree,
} from "antd";
import { CSVLink } from "react-csv";
import { useNavigate } from "react-router-dom";
import { CALL_API } from "../../../Common/api";
import UIModal from "../../../Reusablecomponents/UIModal";
import { ReactComponent as Icon } from "../../../../src/assets/images/kpm.svg";
import { ReactComponent as GConfig } from "../../../../src/assets/images/GConfig.svg";
import { ReactComponent as GCopy } from "../../../../src/assets/images/GCopy.svg";
import { ReactComponent as GSync } from "../../../../src/assets/images/GSync.svg";
import { ReactComponent as GDelete } from "../../../../src/assets/images/GDelete.svg";
import GSort from "../../../../src/assets/images/GSort.svg";
import { ReactComponent as GeoDelete } from "../../../../src/assets/images/GeoDelete.svg";
import { ReactComponent as GExport } from "../../../../src/assets/images/GExport.svg";
import { ReactComponent as GKPM } from "../../../../src/assets/images/GKPM.svg";
import { ReactComponent as Drop } from "../../../../src/assets/images/drop.svg";
import { ReactComponent as GArrow } from "../../../../src/assets/images/GArrow.svg";
import Styled from "styled-components";
import dayjs from "dayjs";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../../Reusablecomponents/UIButtons";
import { useDispatch, useSelector } from "react-redux";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { ReactComponent as IntelSearch } from "../../../../src/assets/images/Frame 1233.svg";

dayjs.extend(utc);
dayjs.extend(timezone);

const Styledashboard = Styled.div`
.title {
font-weight: 600;
font-style: Semi Bold;
font-size: 18px;
color: #3D3D3D;
height: 17px;
width: 190px;
margin-top: 6px;
}
.container_for_header_subtwo {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap; /* allows wrapping instead of shrinking */
}
  .select_icon_dropdown {
  flex: 1;          /* expand to take leftover space */
  max-width: 350px; /* but not beyond */
  min-width: 200px; /* keep it usable */
}
.container_for_header_subtwo > *:not(.select_icon_dropdown) {
  flex-shrink: 0; /* icons won't shrink */
}

    /* Style only the icon/button on the right */
  .green-search-icon .ant-input-search-button {
    background: #06ce06 !important;
    border-color: #06ce06 !important;
    color: white !important;
  }

  /* Make hover consistent */
  .green-search-icon .ant-input-search-button:hover {
    background: #05b605 !important;
    border-color: #05b605 !important;
  }
  /* Remove unwanted spacing before prefix icon */
  .custom-search .ant-input-prefix {
    margin-right: 6px !important; /* Keep small gap between icon & text */
    margin-left: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-left: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  /* Remove internal padding on input caused by prefix */
  .custom-search.ant-input-affix-wrapper {
    padding-left: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #00bc13 !important;
  border-color: #00bc13 !important;
}
.ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: #00bc13 !important;
}
.container_scrollable{
  height : calc(100vh - 140px) !important;
  overflow-y: scroll !important;
}
.scrollablle_container_two{
  height : calc(100vh - 340px) !important;
  overflow-y: scroll !important;
}
  `;
const { Panel } = Collapse;
const { Search } = Input;
const { TextArea } = Input;
const GeoFence = () => {
  const navigate = useNavigate();
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [companyList, setCompanyList] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectedFences, setSelectedFences] = useState([]);
  const [fenceList, setFenceList] = useState([]);
  const [copyTargetAgent, setCopyTargetAgent] = useState({
    guid: null,
    name: "",
    type: null,
  });
  const [sortFields, setSortFields] = useState([]);
  const [agentCopy, setAgentCopy] = useState([]); // array of selected node IDs
  const [selectedAgent, setSelectedAgent] = useState({ guid: null, name: "" });
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isCopyModalVisible, setIsCopyModalVisible] = useState(false);
  const [isSyncModalVisible, setIsSyncModalVisible] = useState(false);
  const [isConfigModalVisible, setIsConfigModalVisible] = useState(false);
  const [data, setData] = useState([]);
  const [treeList, setTreeList] = useState([]);
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const [openPanels, setOpenPanels] = useState([]);
  const csvLinkEl = useRef();
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [searchTree, setSearchTree] = useState("");
  const [Reciepenttype, setReciepenttype] = useState([]);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const createAllowed = useMemo(
    () => hasPermission("GEO", "CF"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("GEO", "DF"),
    [reduxPermissions],
  );
  const copyAllowed = useMemo(
    () => hasPermission("GEO", "CYF"),
    [reduxPermissions],
  );
  const syncAllowed = useMemo(
    () => hasPermission("GEO", "SY"),
    [reduxPermissions],
  );
  const configAllowed = useMemo(
    () => hasPermission("GEO", "CG"),
    [reduxPermissions],
  );
    const exportAllowed = useMemo(
    () => hasPermission("GEO", "EX"),
    [reduxPermissions],
  );
  // const Reciepenttype = [
  //   {
  //     name: "Consignor",
  //     value: 1,
  //     GUID: "d947bc56-14ab-4a1e-abd5-61d62d48c461",
  //   },
  //   {
  //     name: "Transporter",
  //     value: 2,
  //     GUID: "b7da9541-84c8-49a4-9fd3-550633598f5f",
  //   },
  //   {
  //     name: "Consignee",
  //     value: 3,
  //     GUID: "8c6159ce-50f1-4789-9e00-861f250c419e",
  //   },
  // ];

  const fetchAllFenceTypes = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", "geoFence/fence_types", {
        FAgentGUID: userInfo?.ECTSCompId,
      });
      setReciepenttype(data);
    } catch (error) {
      console.error("[fetchAllFenceTypes] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  function filterTree(nodes, search) {
    if (!search) return nodes;
    return nodes
      .map((node) => {
        if (node.FName?.toLowerCase().includes(search.toLowerCase())) {
          return node;
        }
        if (Array.isArray(node.FChild)) {
          const filteredChildren = filterTree(node.FChild, search);
          if (filteredChildren.length > 0) {
            return { ...node, FChild: filteredChildren };
          }
        }
        return null;
      })
      .filter(Boolean);
  }
  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedKeys(fenceList?.map((item) => item.FGUID));
    } else {
      setSelectedKeys([]);
    }
  };

  const handleCheckboxChange = (id) => {
    if (selectedKeys.includes(id)) {
      setSelectedKeys(selectedKeys.filter((key) => key !== id));
    } else {
      setSelectedKeys([...selectedKeys, id]);
    }
  };

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const [formValues, setFormValues] = useState({
    enterFence: true,
    exitFence: false,
    exitFenceUnlocked: false,
    unlockInFence: false,
    fenceOverstay: false,
    stayTime: 0,
    speedLimitInside: false,
    speedLimitThreshold: 0,
    fenceAutomation: true,
    enterCommand: "",
    exitCommand: "",
  });

  // Dummy tree data
  const treeData = [
    {
      title: "KPM Tech Solution [106]",
      key: "0",
      children: [
        {
          title: "KPM Tech Solution [157]",
          key: "0-0",
          children: [
            { title: "KCA403V", key: "0-0-0" },
            { title: "8294830272", key: "0-0-1" },
            { title: "KSX437", key: "0-0-2" },
          ],
        },
      ],
    },
  ];

  const handleSwitchChange = (field, checked) => {
    setFormValues({ ...formValues, [field]: checked });
  };

  const handleInputChange = (field, e) => {
    setFormValues({ ...formValues, [field]: e.target.value });
  };

  const fetchAllCompany = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllCompany");
      setCompanyList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllCompany] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAllCompany();
    fetchAllFenceTypes();
  }, []);
  const [search, setSearch] = useState("");
  const [search1, setSearch1] = useState("");

  const handleSearch = (val) => {
    setSearch(val);
    setCurrentPage(1); // reset pagination
  };
  const handleSearch1 = (val) => {
    setSearch1(val);
  };
  function isParentNode(nodes, guid) {
    for (const node of nodes) {
      if (node.FGUID === guid) {
        return Array.isArray(node.FChild) && node.FChild.length > 0;
      }
      if (Array.isArray(node.FChild)) {
        const found = isParentNode(node.FChild, guid);
        if (found !== null) return found;
      }
    }
    return null;
  }
  const fetchAllFences = useCallback(async () => {
    const agentGUID = selectedAgent.guid || userInfo?.ECTSCompId;
    if (!agentGUID) return;

    // Determine if selected node is parent or leaf
    // On initial load, FType should be 0
    let FType = 0;
    if (selectedAgent.guid) {
      // Only use parent/leaf logic after user selects a node
      const parentStatus = isParentNode(
        Array.isArray(treeList) ? treeList : [treeList],
        agentGUID,
      );
      FType = parentStatus ? 0 : 1;
    }

    try {
      setLoading(true);
      const { data } = await CALL_API("POST", "geoFence/list_fences", {
        FAction: "QueryGISDirectlyUnderFenceByFAgentGUID",
        FAgentGUID: agentGUID,
        FIsAll: 0,
        FType,
        FKey: search,
        FPageSize: pageSize,
        FPageIndex: currentPage,
        FTokenID: "05463e39-8da7-479f-9377-c990bd17f76c",
        FTimeDifferent: 10800,
        FLanguage: "0",
      });
      setFenceList(data?.fences);
      setTotal(data?.totalRecords);
    } catch (error) {
      console.error("[fetchAllFences] error:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedAgent.guid, userInfo?.ECTSCompId, pageSize, currentPage, search]); // dependency

  useEffect(() => {
    fetchAllFences();
  }, [fetchAllFences]);

  const handleDelete = async () => {
    if (selectedKeys.length === 0) {
      message.warning("Please select at least one fence to delete.");
      return;
    }
    try {
      setLoading(true);
      const { data, ResponseCode } = await CALL_API(
        "POST",
        `geoFence/delete_fences`,
        {
          FGUIDs: selectedKeys.join(","),
        },
      );
      if (ResponseCode === 200) {
        message.success("Fence(s) deleted successfully!");
        setSelectedKeys([]);
        fetchAllFences();
      } else {
        message.error("Failed to delete fence(s).");
      }
    } catch (error) {
      console.error("Error deleting Fence:", error);
      message.error("An error occurred while deleting the fence(s).");
    } finally {
      setLoading(false);
      setIsDeleteModalVisible(false); // Close the modal
    }
  };
  const handleCopy = async () => {
    if (selectedKeys.length === 0) {
      message.warning("Please select at least one fence to copy.");
      return;
    }
    if (!copyTargetAgent.guid) {
      message.warning("Please select a target agent to copy to.");
      return;
    }
    try {
      setLoading(true);
      const { data, ResponseCode } = await CALL_API(
        "POST",
        `geoFence/copy_fence`,
        {
          FGUIDs: selectedKeys.join(","),
          FFenceGUID: copyTargetAgent.type,
          FAgentGUID: copyTargetAgent.guid,
        },
      );

      if (ResponseCode === 200) {
        message.success("Fence(s) copied successfully!");
        fetchAllFences();
        setIsCopyModalVisible(false);
      } else {
        console.warn("Copy failed", data);
        message.error("Failed to copy Fence(s).");
      }
    } catch (error) {
      console.error("Error copying Fence:", error);
      message.error("An error occurred while copying the fence(s).");
    } finally {
      setLoading(false);
    }
  };
  const handleSync = async () => {
    if (selectedKeys.length === 0) {
      message.warning("Please select at least one fence to sync.");
      return;
    }
    try {
      setLoading(true);
      // Find the selected fence records
      const selectedFences = fenceList.filter((fence) =>
        selectedKeys.includes(fence.FGUID),
      );
      // Build FFenceList with correct FFenceTypeGUID for each fence
      const FFenceList = selectedFences.map((fence) => ({
        FFenceTypeGUID: fence.FFenceTypeGUID,
        FGUID: fence.FGUID,
      }));
      const { data, ResponseCode } = await CALL_API(
        "POST",
        `geoFence/sync_fence`,
        {
          FAgentGUID: selectedAgent.guid,
          FType: 0,
          FFenceList,
        },
      );

      if (ResponseCode === 200) {
        message.success("Fence(s) synced successfully!");
        setIsSyncModalVisible(false);
        fetchAllFences();
      } else {
        console.warn("Sync failed", data);
        message.error("Failed to sync Fence(s).");
      }
    } catch (error) {
      console.error("Error syncing Fence:", error);
      message.error("An error occurred while syncing the fence(s).");
    } finally {
      setLoading(false);
    }
  };
  const handleConfig = async () => {
    if (selectedKeys.length === 0) {
      message.warning("Please select at least one fence to config.");
      return;
    }
    try {
      setLoading(true);
      // Find the selected fence records
      const selectedFences = fenceList.filter((fence) =>
        selectedKeys.includes(fence.FGUID),
      );
      // Build FFenceList with correct FFenceTypeGUID for each fence
      const FFenceList = selectedFences.map((fence) => ({
        FFenceTypeGUID: fence.FFenceTypeGUID,
        FGUID: fence.FGUID,
      }));
      const { data, ResponseCode } = await CALL_API(
        "POST",
        `geoFence/fence_config`,
        {
          FVehicleGUID: "",
          FFenceGUID: "b1a7c7ca-5696-44d4-bb6d-38c13207e4a2",
          FInAlarm: 1,
          FOutAlarm: 1,
          FStopAlarm: 1,
          FStopTime: 7200,
          FOverspeedAlarm: 1,
          FOverspeedValue: 110,
          FOutUnLockAlarm: 1,
          FUnLockFence: 1,
          FAwaken: 0,
          FOffline: 0,
          FInAwakenIns: "",
          FOutSleepIns: "",
        },
      );

      if (ResponseCode === 200) {
        message.success("Fence(s) config done successfully!");
        setIsConfigModalVisible(false);
        fetchAllFences();
      } else {
        console.warn("Config failed", data);
        message.error("Failed to config Fence(s).");
      }
    } catch (error) {
      console.error("Error in Fence config:", error);
      message.error("An error occurred while config the fence(s).");
    } finally {
      setLoading(false);
    }
  };

  const getFenceTree = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", "geoFence/tree-without-fence", {
        FAgentGUID: userInfo?.ECTSCompId || "",
      });
      setTreeList(data);
    } catch (error) {
      console.error("[getFenceTree] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getFenceTree();
  }, []);
  function getAllPanelKeys(nodes) {
    let keys = [];
    nodes.forEach((node) => {
      if (Array.isArray(node.FChild) && node.FChild.length > 0) {
        keys.push(node.FGUID);
        keys = keys.concat(getAllPanelKeys(node.FChild));
      }
    });
    return keys;
  }

  const allPanelKeys = Array.isArray(treeList)
    ? getAllPanelKeys(treeList)
    : getAllPanelKeys([treeList]);

  // Recursive renderer for treeList
  const renderTree = (
    nodes,
    setAgentFn,
    level = 0,
    mode = "main",
    parentFGUID = null,
  ) => {
    return nodes.map((node) => {
      const hasChildren = Array.isArray(node.FChild) && node.FChild.length > 0;
      const isSelected = selectedAgent.guid === node.FGUID;
      // Panel header with selection highlighting
      const header = (
        <div
          onClick={(e) => handleLeafClick(node, e)}
          style={{
            display: "flex",
            alignItems: "center",
            fontWeight: level === 0 ? 600 : 500,
            fontSize: level === 0 ? "16px" : "14px",
            color: isSelected ? "#2C963D" : "#3D3D3D",
            background: isSelected
              ? "#D4F5D4"
              : level === 0
                ? "#E8FFEC"
                : "#F5FFF8",
            padding: "4px 8px",
            borderRadius: 6,
            border: isSelected ? "2px solid #2C963D" : "1px solid transparent",
            cursor: "pointer", // Make it clear it's clickable
          }}
        >
          {level === 0 ? (
            <GKPM style={{ marginRight: 8, flexShrink: 0 }} />
          ) : (
            <Drop style={{ marginRight: 8, flexShrink: 0 }} />
          )}
          {node.FName}
        </div>
      );

      // Leaf click handler
      const handleLeafClick = (node, e, parentFGUID) => {
        if (e && e.stopPropagation) e.stopPropagation();
        const recipient = (Reciepenttype || []).find(
          (r) =>
            r.name &&
            node.FName &&
            r.name.toLowerCase() === node.FName.toLowerCase(),
        );
        const agent = recipient
          ? {
              guid: parentFGUID, // parent company FGUID
              name: node.FName,
              type: recipient.FGUID,
            }
          : {
              guid: node.FGUID, // company node
              name: node.FName,
              type: "",
            };
        setAgentFn(agent);
        if (mode === "main") {
          setSelectedAgent(agent);
        }
      };

      if (hasChildren) {
        return (
          <Panel
            key={node.FGUID}
            style={{ border: "none" }}
            header={header}
            // Note: defaultActiveKey is optional based on how you want it to expand
          >
            <Collapse
              bordered={false}
              expandIconPosition="end"
              expandIcon={({ isActive }) => (
                <GArrow
                  size={18}
                  style={{
                    transform: isActive ? "rotate(0deg)" : "rotate(180deg)",
                    transition: "transform 0.2s",
                  }}
                />
              )}
            >
              {renderTree(node.FChild, setAgentFn, level + 1, mode, node.FGUID)}
            </Collapse>
          </Panel>
        );
      }

      // Leaf node — clickable, with checkbox in copy mode
      if (mode === "copy") {
        return (
          <div
            key={node.FGUID}
            style={{
              cursor: "pointer",
              marginLeft: level * 20,
              display: "flex",
              alignItems: "center",
              color:
                copyTargetAgent.guid === (parentFGUID || node.FGUID)
                  ? "#2C963D"
                  : "#3D3D3D",
              padding: "6px 0",
              gap: 8,
              background:
                copyTargetAgent.guid === (parentFGUID || node.FGUID)
                  ? "#D4F5D4"
                  : "transparent",
              borderRadius: 4,
            }}
          >
            <Checkbox
              checked={
                copyTargetAgent.guid === parentFGUID &&
                copyTargetAgent.type ===
                  ((Reciepenttype || []).find(
                    (r) =>
                      r.name &&
                      node.FName &&
                      r.name.toLowerCase() === node.FName.toLowerCase(),
                  )?.FGUID || "")
              }
              onChange={(e) => handleLeafClick(node, e, parentFGUID)}
            />
            <Drop style={{ marginRight: 8 }} />
            {node.FName}
          </div>
        );
      }

      // Default leaf node (main mode) with selection highlighting
      return (
        <div
          key={node.FGUID}
          onClick={(e) => handleLeafClick(node, e, parentFGUID)}
          style={{
            cursor: "pointer",
            marginLeft: level * 20,
            display: "flex",
            alignItems: "center",
            color: isSelected ? "#2C963D" : "#3D3D3D",
            padding: "6px 0",
            background: isSelected ? "#D4F5D4" : "transparent",
            borderRadius: 4,
            fontWeight: isSelected ? 600 : 400,
          }}
        >
          <Drop style={{ marginRight: 8 }} />
          {node.FName}
        </div>
      );
    });
  };
  const [tableSort, setTableSort] = useState({
    field: null,
    order: null, // 'ascend' or 'descend'
  });
  const allOptions = [
    "FAgentName",
    "FName",
    "FTypeName",
    "aasset",
    "FArea",
    "FRadius",
    "FCreateTime",
  ];

  const columns = [
    {
      title: (
        <Checkbox
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => handleSelectAll(e.target.checked)}
          checked={
            fenceList.length > 0 && selectedKeys.length === fenceList.length
          }
          indeterminate={
            selectedKeys.length > 0 && selectedKeys.length < fenceList.length
          }
        />
      ),
      dataIndex: "checkbox",
      key: "checkbox",
      width: "15%",
      render: (_, record) => (
        <Checkbox
          checked={selectedKeys.includes(record.FGUID)}
          onClick={(e) => e.stopPropagation()}
          onChange={() => handleCheckboxChange(record.FGUID)}
        />
      ),
    },
    {
      title: "Index",
      dataIndex: "RowNo",
      key: "RowNo",
      width: "10%",
    },
    {
      title: "Company",
      dataIndex: "FAgentName",
      key: "FAgentName",
      width: "50%",
      sorter: (a, b) => (a.FAgentName || "").localeCompare(b.FAgentName || ""),
      sortOrder: tableSort.field === "FAgentName" ? tableSort.order : null,
    },
    {
      title: "Name",
      dataIndex: "FName",
      key: "FName",
      width: "20%",
      sorter: (a, b) => (a.FName || "").localeCompare(b.FName || ""),
      sortOrder: tableSort.field === "FName" ? tableSort.order : null,
    },
    {
      title: "Fence Type",
      dataIndex: "FTypeName",
      key: "FTypeName",
      width: "15%",
      sorter: (a, b) => (a.FTypeName || "").localeCompare(b.FTypeName || ""),
      sortOrder: tableSort.field === "FTypeName" ? tableSort.order : null,
    },
    {
      title: "Fence Style",
      dataIndex: "FRadius",
      key: "FRadius",
      width: "20%",
      sorter: (a, b) => (a.FRadius || 0) - (b.FRadius || 0),
      sortOrder: tableSort.field === "FRadius" ? tableSort.order : null,
      render: (value) => (value === 0 ? "Polygon" : "Circle"),
    },
    {
      title: "Associated Asset",
      dataIndex: "aasset",
      key: "aasset",
      width: "20%",
      sorter: (a, b) => (a.aasset || "").localeCompare(b.aasset || ""),
      sortOrder: tableSort.field === "aasset" ? tableSort.order : null,
    },
    {
      title: "Area (Km²)",
      dataIndex: "FArea",
      key: "FArea",
      width: "20%",
      sorter: (a, b) => Number(a.FArea) - Number(b.FArea),
      sortOrder: tableSort.field === "FArea" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "-";
        return (value / 1_000_000).toFixed(3);
      },
    },
    {
      title: "Radius (Km)",
      dataIndex: "FRadius",
      key: "FRadius",
      width: "20%",
      sorter: (a, b) => Number(a.FRadius) - Number(b.FRadius),
      sortOrder: tableSort.field === "FRadius" ? tableSort.order : null,
      render: (value) => {
        return (value / 1000).toFixed(2);
      },
    },
    {
      title: "Location",
      dataIndex: "FAddress",
      key: "FAddress",
      width: "20%",
    },
    {
      title: "Description",
      dataIndex: "FRemark",
      key: "FRemark",
      width: "20%",
    },
    {
      title: "Create Time",
      dataIndex: "FCreateTime",
      key: "FCreateTime",
      width: "20%",
      sorter: (a, b) => new Date(a.FCreateTime) - new Date(b.FCreateTime),
      sortOrder: tableSort.field === "FCreateTime" ? tableSort.order : null,
      render: (text) =>
        text ? dayjs(text).format("DD/MM/YYYY HH:mm:ss") : "-",
    },
    {
      title: "Longitude",
      dataIndex: "FCenterLon",
      key: "FCenterLon",
      width: "20%",
    },
    {
      title: "Latitude",
      dataIndex: "FCenterLat",
      key: "FCenterLat",
      width: "20%",
    },
  ];

  const prepareCSV = async () => {
    try {
      setCSVLoader(true);
      const { data } = await CALL_API("POST", `geoFence/list_fences`, {
        FAction: "QueryGISDirectlyUnderFenceByFAgentGUID",
        FAgentGUID: selectedAgent.guid || userInfo?.ECTSCompId,
        FIsAll: 0,
        FType: 0,
        FKey: "",
        FPageSize: total,
        FPageIndex: currentPage,
        FTokenID: "05463e39-8da7-479f-9377-c990bd17f76c",
        FTimeDifferent: 10800,
        FLanguage: "0",
      });

      if (data?.fences?.length > 0) {
        setCSVList(
          data?.fences.map((item) => ({
            Company: item.FAgentName || "-",
            Name: item.FName || "-",
            "Fence Type": item.FTypeName || "-",
            "Fence Style": item.FRadius === 0 ? "Polygon" : "Circle",
            "Associated Asset": item.aasset || "-",
            "Area (Km²)": item.FArea
              ? (item.FArea / 1_000_000).toFixed(3)
              : "-",
            "Radius (Km)": item.FRadius
              ? (item.FRadius / 1000).toFixed(2)
              : "0.00",
            Location: item.FAddress || "-",
            Description: item.FRemark || "-",
            "Create Time": item.FCreateTime
              ? dayjs(item.FCreateTime).format("DD/MM/YYYY HH:mm:ss")
              : "-",
            Longitude: item.FCenterLon || "-",
            Latitude: item.FCenterLat || "-",
          })),
        );

        setTimeout(() => {
          csvLinkEl.current?.link?.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("CSV export error -->", error);
    } finally {
      setCSVLoader(false);
    }
  };
  function getCompanyNameByFGUID(nodes, guid) {
    for (const node of nodes) {
      if (node.FGUID === guid) return node.FName;
      if (Array.isArray(node.FChild)) {
        const found = getCompanyNameByFGUID(node.FChild, guid);
        if (found) return found;
      }
    }
    return "";
  }
  const handleSortOptionsChange = (checkedValues) => {
    setSortFields(checkedValues);
  };
  const onCheckAllChange = (e) => {
    const isChecked = e.target.checked;
    setSortFields(isChecked ? allOptions : []);
  };
  // const content = (
  //   <Styledashboard>
  //     <div className="checkbox_group_container">
  //       <Checkbox
  //         indeterminate={
  //           sortFields.length > 0 && sortFields.length < allOptions.length
  //         }
  //         onChange={onCheckAllChange}
  //         checked={sortFields.length === allOptions.length}
  //       >
  //         All
  //       </Checkbox>

  //       <Checkbox.Group value={sortFields} onChange={handleSortOptionsChange}>
  //         <div className="checkbox_group_container">
  //           <Checkbox value="FAgentName">Company</Checkbox>
  //           <Checkbox value="FName">Name</Checkbox>
  //           <Checkbox value="FTypeName">Fence Type</Checkbox>
  //           <Checkbox value="aasset">Associated Asset</Checkbox>
  //           <Checkbox value="FArea">Area</Checkbox>
  //           <Checkbox value="FRadius">Radius</Checkbox>
  //           <Checkbox value="FCreateTime">Create Time</Checkbox>
  //         </div>
  //       </Checkbox.Group>
  //     </div>
  //   </Styledashboard>
  // );
  return (
    <Styledashboard>
      <div style={{ padding: "16px", background: "#f0f2f5" }}>
        <Row gutter={[0, 16]} style={{ margin: 0 }}>
          {/* Left White Box */}
          {userInfo?.MCID === 59 && userInfo?.SYSADM === true && (
            <Col
              style={{
                flex: "0 0 350px",
                maxWidth: 350,
                minWidth: 350,
                paddingRight: 0,
                paddingLeft: 0,
              }}
            >
              {" "}
              <Card
                className="container_scrollable"
                style={{
                  borderRadius: "12px",
                  height: "100%",
                  width: "100%",
                  marginRight: "20px",
                }}
              >
                <div>
                  {/* Search bar */}
                  <Input
                    className="custom-search "
                    allowClear
                    placeholder="Enter keywords"
                    value={searchTree}
                    prefix={
                      <IntelSearch
                        style={{
                          cursor: "pointer",
                        }}
                      />
                    }
                    onChange={(e) => setSearchTree(e.target.value)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  />
                  <br />
                  {/* Dropdown items */}
                  <Collapse
                    bordered={false}
                    expandIconPosition="end"
                    activeKey={allPanelKeys}
                    expandIcon={({ isActive }) => (
                      <GArrow
                        size={18}
                        style={{
                          transform: isActive
                            ? "rotate(0deg)"
                            : "rotate(180deg)",
                          transition: "transform 0.2s",
                        }}
                      />
                    )}
                  >
                    {Array.isArray(treeList)
                      ? renderTree(
                          filterTree(treeList, searchTree),
                          setSelectedAgent,
                          0,
                          "main",
                        )
                      : renderTree(
                          filterTree([treeList], searchTree),
                          setSelectedAgent,
                          0,
                          "main",
                        )}
                  </Collapse>
                </div>
              </Card>
            </Col>
          )}
          {/* Right White Box */}
          <Col
            style={{ flex: 1, minWidth: 0, paddingLeft: 15, paddingRight: 0 }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <Card
                style={{
                  borderRadius: "12px",
                  height: "100%",
                  width: "100%", // lock width to col size
                  overflow: "hidden", // prevent overflow messing layout
                }}
              >
                <div className="container_for_header_subtwo">
                  <Icon /> <p className="title">{userInfo?.COMPNAME}</p>
                  <Tooltip title={!createAllowed ? "No permission" : ""}>
                    <ButtonFilled
                      type="primary"
                      disabled={!createAllowed}
                      onClick={() =>
                        navigate("/GeoDetails", { state: { mode: "add" } })
                      }
                    >
                      + Add Fence
                    </ButtonFilled>
                  </Tooltip>
                </div>
                <br />
                <div className="container_for_header_subtwo">
                  <Tooltip title={!deleteAllowed ? "No permission" : ""}>
                    <GDelete
                      style={{
                        cursor: deleteAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!deleteAllowed) return;
                        if (selectedKeys.length === 0) {
                          message.warning(
                            "Please select a geofence before attempting to delete.",
                          );
                          return;
                        }
                        setIsDeleteModalVisible(true);
                      }}
                    />
                  </Tooltip>
                  <Tooltip title={!configAllowed ? "No permission" : ""}>
                    <GConfig
                      style={{
                        cursor: configAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!configAllowed) return;
                        if (selectedKeys.length === 0) {
                          message.warning(
                            "Please select a geofence before attempting to config.",
                          );
                          return;
                        }
                        setIsConfigModalVisible(true);
                      }}
                    />
                  </Tooltip>
                  <Tooltip title={!syncAllowed ? "No permission" : ""}>
                    <GSync
                      style={{
                        cursor: syncAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!syncAllowed) return;
                        if (selectedKeys.length === 0) {
                          message.warning(
                            "Please select a geofence before attempting to sync.",
                          );
                          return;
                        }
                        setIsSyncModalVisible(true);
                      }}
                    />
                  </Tooltip>
                  <Tooltip title={!copyAllowed ? "No permission" : ""}>
                    <GCopy
                      style={{
                        cursor: copyAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!copyAllowed) return;
                        if (selectedKeys.length === 0) {
                          message.warning(
                            "Please select a geofence before attempting to copy.",
                          );
                          return;
                        }
                        setIsCopyModalVisible(true);
                      }}
                    />
                  </Tooltip>
                  <Input
                    className="custom-search"
                    style={{ width: 350 }}
                    placeholder="Search"
                    allowClear
                    prefix={
                      <IntelSearch
                        style={{
                          cursor: "pointer",
                        }}
                      />
                    }
                    value={search}
                    onChange={(e) => handleSearch(e.target.value)} // triggers as you type
                    onSearch={handleSearch} // still works when pressing Enter or clicking Search icon
                  />
                  {/* <GFilter style={{ cursor: "pointer" }} /> */}
                  {/* <Popover content={content} trigger="click">
                    <img
                      src={GSort}
                      alt="Sort"
                      style={{
                        cursor: "pointer",
                        marginRight: "30px",
                        backgroundColor: "#EBF7ED",
                        borderRadius: "6px",
                      }}
                      onClick={(e) => e.preventDefault()}
                    />
                  </Popover>{" "} */}
                  <Spin spinning={CSVLoader}>
                    <GExport
                      style={{ cursor: "pointer" }}
                      onClick={()=>{
                        if (!exportAllowed) return;
                        prepareCSV()}}
                    />
                  </Spin>
                  <CSVLink
                    data={CSVList}
                    filename={"GeoFence.csv"}
                    asyncOnClick={true}
                    ref={csvLinkEl}
                  />
                </div>

                {/* Table with scroll */}
                <div className="scrollablle_container_two">
                  <Spin spinning={loading}>
                    {total > 0 && (
                      <StyledTable
                        className="mt-4"
                        dataSource={fenceList}
                        columns={columns}
                        pagination={false}
                        style={{ cursor: "pointer" }}
                        onRow={(record) => ({
                          onClick: () => {
                            navigate(`/GeoDetails`, {
                              state: {
                                ...record,
                                mode: "view",
                              },
                            });
                          },
                        })}
                        onChange={(pagination, filters, sorter) => {
                          setTableSort({
                            field: sorter.field,
                            order: sorter.order,
                          });
                        }}
                        rowKey="FGUID" // make sure this matches your data or fallback key
                      />
                    )}
                    <ReusablePagination
                      pageSize={pageSize}
                      handlePageSizeChange={handlePageSizeChange}
                      currentPage={currentPage}
                      total={total}
                      handlePageChange={handlePageChange}
                    />
                  </Spin>
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
      <UIModal
        width={500}
        open={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)} // Close the modal
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <GeoDelete />
          <h3>Delete Geofence?</h3>
          <p>
            This action will permanently delete the selected Geofence. Do you
            want to proceed?
          </p>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              onClick={handleDelete} // Call the delete function
              loading={loading}
            >
              Confirm
            </ButtonFilled>
            <Buttontransparent
              onClick={() => setIsDeleteModalVisible(false)} // Close the modal
            >
              Cancel
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <UIModal
        width={500}
        open={isSyncModalVisible}
        onClose={() => setIsSyncModalVisible(false)} // Close the modal
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h6>
            Are you sure to synchronize the selected{" "}
            <b>
              [{selectedKeys.length} fence{selectedKeys.length > 1 ? "s" : ""}]
            </b>{" "}
            to the subsidiary of <b>[{selectedAgent?.name || "----"}]</b>?
          </h6>

          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              onClick={handleSync} // Call the sync function
              loading={loading}
            >
              Confirm
            </ButtonFilled>
            <Buttontransparent
              onClick={() => setIsSyncModalVisible(false)} // Close the modal
            >
              Cancel
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <Modal
        title="Copy Geofence"
        open={isCopyModalVisible}
        onCancel={() => setIsCopyModalVisible(false)}
        footer={[
          <Buttontransparent onClick={() => setIsCopyModalVisible(false)}>
            Cancel
          </Buttontransparent>,
          <ButtonFilled key="save" type="primary" onClick={handleCopy}>
            Copy
          </ButtonFilled>,
        ]}
        width={500} // adjust modal size
      >
        <Card style={{ borderRadius: "12px", height: "100%" }}>
          <div>
            <b>Choose where you want to paste fence</b>
            {copyTargetAgent.guid && copyTargetAgent.name && (
              <div style={{ marginTop: 16, fontWeight: 500, color: "#2C963D" }}>
                Paste the fence to:{" "}
                <span style={{ color: "#222" }}>
                  {getCompanyNameByFGUID(treeList, copyTargetAgent.guid)} →{" "}
                  {copyTargetAgent.name}
                </span>
              </div>
            )}
            {/* Search bar */}
            <Search
              className="select_icon_dropdown"
              style={{ width: "100%" }}
              placeholder="Search"
              allowClear
              value={search1}
              onChange={(e) => handleSearch1(e.target.value)} // triggers as you type
              onSearch={handleSearch1} // still works when pressing Enter or clicking Search icon
            />

            <br />

            {/* Dropdown items */}
            {loading ? (
              <Spin />
            ) : (
              <Collapse
                bordered={false}
                expandIconPosition="end"
                expandIcon={({ isActive }) => (
                  <GArrow
                    size={18}
                    style={{
                      transform: isActive ? "rotate(0deg)" : "rotate(180deg)",
                      transition: "transform 0.2s",
                    }}
                  />
                )}
              >
                {Array.isArray(treeList)
                  ? renderTree(treeList, setCopyTargetAgent, 0, "copy")
                  : renderTree([treeList], setCopyTargetAgent, 0, "copy")}
              </Collapse>
            )}
          </div>
        </Card>
      </Modal>
      <Modal
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ fontWeight: 600 }}>Geofence Configuration</span>
            <span style={{ fontSize: "14px", color: "#6B7280" }}>
              Selected: {selectedFences.length} Fences, {selectedDevices.length}{" "}
              Devices
            </span>
          </div>
        }
        open={isConfigModalVisible}
        onCancel={() => setIsConfigModalVisible(false)}
        footer={[
          <Buttontransparent
            key="cancel"
            onClick={() => setIsConfigModalVisible(false)}
          >
            Cancel
          </Buttontransparent>,
          <ButtonFilled key="save" type="primary" onClick={handleConfig}>
            Update
          </ButtonFilled>,
        ]}
        width={960}
        bodyStyle={{ padding: "20px" }}
      >
        <div style={{ display: "flex", gap: "20px" }}>
          {/* Left Panel */}
          <div style={{ flex: 1 }}>
            <Input.Search
              placeholder="Search"
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
              allowClear
              style={{ marginBottom: "12px", borderRadius: "8px" }}
            />
            <div
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                padding: "10px",
                height: "400px",
                overflowY: "auto",
                background: "#fff",
              }}
            >
              <Tree
                treeData={treeData}
                defaultExpandAll
                selectedKeys={selectedFences}
                onSelect={(selectedKeys) => setSelectedFences(selectedKeys)}
                showIcon
              />
            </div>
          </div>

          {/* Right Panel */}
          <div style={{ flex: 1 }}>
            <div
              style={{
                marginBottom: "16px",
                fontSize: "14px",
                color: "#374151",
              }}
            >
              <b>Geofence Alarm Configuration</b>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <span>Enter fence</span>
              <Switch
                checked={formValues.enterFence}
                onChange={(checked) =>
                  handleSwitchChange("enterFence", checked)
                }
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <span>Exit fence</span>
              <Switch
                checked={formValues.exitFence}
                onChange={(checked) => handleSwitchChange("exitFence", checked)}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <span>Exit fence - unlocked</span>
              <Switch
                checked={formValues.exitFenceUnlocked}
                onChange={(checked) =>
                  handleSwitchChange("exitFenceUnlocked", checked)
                }
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <span>Unlock in fence</span>
              <Switch
                checked={formValues.unlockInFence}
                onChange={(checked) =>
                  handleSwitchChange("unlockInFence", checked)
                }
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <span>Fence overstay</span>
              <Switch
                checked={formValues.fenceOverstay}
                onChange={(checked) =>
                  handleSwitchChange("fenceOverstay", checked)
                }
              />
            </div>

            <div
              style={{
                display: "flex",
                gap: "12px",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <span style={{ width: "120px" }}>Stay time (min)</span>
              <Input
                type="number"
                value={formValues.stayTime}
                onChange={(e) => handleInputChange("stayTime", e)}
                style={{ borderRadius: "8px", width: "100px" }}
              />
            </div>

            <div
              style={{
                display: "flex",
                gap: "12px",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <Switch
                checked={formValues.speedLimitInside}
                onChange={(checked) =>
                  handleSwitchChange("speedLimitInside", checked)
                }
              />
              <span style={{ flex: 1 }}>Speed limit inside the fence</span>
              <Input
                type="number"
                value={formValues.speedLimitThreshold}
                onChange={(e) => handleInputChange("speedLimitThreshold", e)}
                placeholder="km/h"
                style={{ width: "120px", borderRadius: "8px" }}
              />
            </div>

            <div
              style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <Switch
                checked={formValues.fenceAutomation}
                onChange={(checked) =>
                  handleSwitchChange("fenceAutomation", checked)
                }
              />
              <span>Fence Automation Instructions</span>
            </div>

            <div style={{ marginBottom: "12px" }}>
              <label style={{ fontSize: "14px", color: "#374151" }}>
                Enter the area to sending commands
              </label>
              <TextArea
                rows={2}
                value={formValues.enterCommand}
                onChange={(e) => handleInputChange("enterCommand", e)}
                style={{ borderRadius: "8px", marginTop: "4px" }}
              />
            </div>

            <div>
              <label style={{ fontSize: "14px", color: "#374151" }}>
                Sending commands out of the area
              </label>
              <TextArea
                rows={2}
                value={formValues.exitCommand}
                onChange={(e) => handleInputChange("exitCommand", e)}
                style={{ borderRadius: "8px", marginTop: "4px" }}
              />
            </div>
          </div>
        </div>
      </Modal>
    </Styledashboard>
  );
};

export default GeoFence;
